const readMore = {
  wrap: document.querySelectorAll(".jsReadMoreWrap") as NodeListOf<HTMLElement>,
  btn: document.querySelectorAll(".jsReadMore") as NodeListOf<HTMLElement>,

  init() {
    this.setBtn()
  },

  setBtn() {
    this.wrap.forEach((item, index) => {
      const child = item.firstElementChild as HTMLElement
      const height = child.offsetHeight
      const itemHeight = item.offsetHeight
      const btn = this.btn[index]

      if (height <= itemHeight) {
        btn.classList.add("d-none")
      }
      btn.addEventListener("click", () => {
        if (btn.dataset.open === "false") {
          btn.dataset.open = "true"
          item.style.maxHeight = height + 30 + "px"
          btn.innerText = "read less "
        } else {
          btn.dataset.open = "false"
          item.style.maxHeight = itemHeight + "px"
          btn.innerText = "read more..."
        }
      })
    })
  },
}

export default readMore
